import React from 'react'
import PropTypes from "prop-types"
import styled from 'styled-components';

const Btn = styled.a`
  padding: .8em 1.9em;
  border: 1px solid #2057F4;
  border-radius: 40px;
  font-size: 1em;
  color: #FFF;
  background-color: #2057F4;
  cursor: pointer;
  text-align: center;
  text-decoration: none;

  &:hover{
    border-color: #3866e8;
    color: #3866e8;
    /* background-color: #3866e8; */
  }

`
const ButtonFlat = ({ children, anchor, size }) => (
  <Btn data-size={size} href={anchor} target="__blank">{children}</Btn>
)


ButtonFlat.propTypes = {
  anchor: PropTypes.string,
  primary: PropTypes.bool,
  size: PropTypes.string,
}

ButtonFlat.defaultProps = {
  anchor: ``,
  primary: true,
  size: 'md'
}


export default ButtonFlat